/**
 * Renderer for link-cell columns: id, building, account, technician (Assigned To).
 *
 * The datatable JSON endpoint returns path fields for navigation:
 *   - id column: item.idPath
 *   - building: item.building (label string) + item.buildingPath
 *   - account:  item.account  (label string) + item.accountPath
 *   - technician (Assigned To): item.technician (label) + item.technicianPath
 *
 * Quimby Table renderer signature: ({ item, dataKey, index }) => ReactNode
 */
import React from 'react';
export function InspectionLinkCellRenderer({ item, dataKey }) {
    if (dataKey === 'id') {
        return (React.createElement("a", { href: item.idPath, className: "--primary-link" }, item.id));
    }
    // building, account, technician — stored as label string + separate *Path field
    const PATH_KEY = {
        building: 'buildingPath',
        account: 'accountPath',
        technician: 'technicianPath'
    };
    const label = item[dataKey];
    const pathKey = PATH_KEY[dataKey];
    const href = pathKey ? item[pathKey] : undefined;
    if (href) {
        return React.createElement("a", { href: href }, label !== null && label !== void 0 ? label : '');
    }
    return React.createElement("span", null, label !== null && label !== void 0 ? label : '');
}
